"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchTransition = exports.time = void 0;
var time = 0.15;
exports.time = time;
var switchTransition = "\n  transition: ".concat(time, "s ease-out;\n");
exports.switchTransition = switchTransition;